import React, { useRef, useState, useContext, lazy, Suspense, useEffect, useCallback } from 'react'
import { addDoc, serverTimestamp } from "firebase/firestore";
import { auth, functions, storage } from '../../firebase.js'
import { ref, uploadBytesResumable, getDownloadURL } from "firebase/storage";
import d13 from './SendQuestionsForm.module.css'



import { BsImageFill } from 'react-icons/bs'
import { AiTwotoneAudio } from 'react-icons/ai'
import { IoImagesOutline, IoText } from 'react-icons/io5'

import { FaPaperPlane } from 'react-icons/fa'

import RecorderHooks from '../ui/Audio-utilities/RecorderHook';
import MiniLoader from '../ui/Visual-utilities/MiniLoader.js';
import BlueButton from '../ui/BlueButton.js';
import { httpsCallable } from 'firebase/functions';
import UserContext from '../../store/UserContext.js';

import { toast } from 'react-toastify';
import DotsLoader from '../ui/Visual-utilities/DotsLoader.js';

//import MultipleImagesUploadForm from '../ui/Image-utilities/MultipleImagesUploadForm.js';
const MultipleImagesUploadForm = lazy(() => import('../ui/Image-utilities/MultipleImagesUploadForm.js'));
function SendQuestionsForm(props) {

  const scroll = useRef();

  const [loader, setLoader] = useState(false);

  //const [imgProgress, setImgProgress] = useState(0);
  const [imgUrl, setImgUrl] = useState({});
  const [imgUpState, setImgUpState] = useState('empty');



  const [toggleQuestionUpload, setToggleQuestionUpload] = useState(false);
  //const [imagePreview, setImagePreview] = useState('')

  const [audioProgress, setAudioProgress] = useState(0);
  const [audioUrl, setAudioUrl] = useState("");
  const [audioUpState, setAudioUpState] = useState(true);
  //const [audioPreview, setAudioPreview] = useState('')

  const [subjectState, setSubjectState] = useState(false)
  let userCtx = useContext(UserContext);
  let userData = userCtx.user;



  const questRef = useRef();
  const subjectRef = useRef();



  useEffect(() => {
    if (toggleQuestionUpload) {
      setLoader(true);
      if (imgUpState === 'empty' || imgUpState === 'done') sendQuestion()
      else {
        console.log('upload launched')

      }
    }
  }, [toggleQuestionUpload, imgUpState])



  function checkSubject() {
    if (subjectRef.current.value !== 'default') {
      setSubjectState(true);
      scroll.current.scrollIntoView({ behavior: 'smooth' })
    }
    else { setSubjectState(false) }
  };

  /*
  //audio & image preview
    function getImagePreview(){
      const url = URL.createObjectURL(imgRef.current.files[0]);
      setImagePreview(url);
    }
  
    function getAudioPreview(){
      const url2 = URL.createObjectURL(audioRef.current.files[0]);
      setAudioPreview(url2);
    }
  
     function handleImgUpload() {
        let enteredImg= imgRef.current.files[0]; //ref
        if (!enteredImg)return;
        console.log(enteredImg)
        // Create the file metadata
       
        const metadata = { contentType: 'image/jpeg-jpg-jpeg' };
      
        const storageRef = ref(storage, 'questions/'+auth.currentUser.uid+'/images/'+ (new Date().toString().substring(0,25))); 
        const uploadTask = uploadBytesResumable(storageRef, enteredImg, metadata);
        uploadTask.on('state_changed',
          (snapshot) => {
            const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
            setImgProgress(progress);
          },{},
          (snapshot) => { 
            getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
             
              setImgUrl(downloadURL);
              setImgUpState(true);
              scroll.current.scrollIntoView({ behavior: 'smooth' })
            }).catch(()=>{toast.error("could not get the Image download URL "); setImgUpState(true);});
          }
        );
        
      }
      */

  function handleAudioUpload(file) {
    // const enteredAudio= audioRef.current.files[0]; //ref
    console.log('audio pre handling', file)
    const enteredAudio = file;
    if (!enteredAudio) return;
    console.log('audio handling', file)
    setAudioUpState(false);
    // Create the file metadata
    /* @type {any} */
    const metadata = {
      contentType: 'audio/mpeg'
    };
    const storageRef = ref(storage, 'from-chrome-mp3----'/* 'questions/'+auth.currentUser.uid+'/audios/' */
      + (new Date().toString().substring(0, 24)));
    const uploadTask = uploadBytesResumable(storageRef, enteredAudio, metadata);
    uploadTask.on('state_changed',
      (snapshot) => {
        const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
        setAudioProgress(progress);
      }, {},
      () => {
        getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
          setAudioUrl(downloadURL);
          setAudioUpState(true);
          scroll.current.scrollIntoView({ behavior: 'smooth' })
        }).catch(() => { toast.error("could not get the audio download URL "); setAudioUpState(true); });
      }
    );

  }





  function sendQuestion() {//add data


    const enteredSubject = subjectRef.current.value;
    const enteredQuestion = questRef.current.value;

    let func = httpsCallable(functions, 'sendQuestion');
    func({//auto generated id
      subject: enteredSubject,
      sender_id: auth.currentUser.uid,
      question: enteredQuestion,
      question_images: imgUrl,
      question_audio: audioUrl,
      prefered_language: userData.preferedLangage || userData.prefered_language,
      grade: userData.grade,
      question_status: 'pending',
      read: false,
      target_teacher: props.targetTeacher
    }).then((e) => {
      console.log('question send', e.data);
      props.close();
    })



  }
  //auto resize text area
  function textareaResize() {
    const tx = document.getElementsByTagName("textarea");
    for (let i = 0; i < tx.length; i++) {
      tx[i].setAttribute("style", "height:" + (tx[i].scrollHeight) + "px;overflow-y:hidden;");
      tx[i].addEventListener("input", OnInput, false);
    }

    function OnInput() {
      this.style.height = "auto";
      this.style.height = (this.scrollHeight) + "px";
    }
  }




  //check if can play opus----------------------------------------------------
  const audio = document.createElement("audio"),
    canPlayOPUS = audio.canPlayType('audio/webm;codecs="opus"') !== "";


  //check if not an emptyquestion
  function emptyQuestion() {
    const enteredQuestion = questRef.current.value;
    const noWhiteEmptySpaces = enteredQuestion.replace(/\n*$/g, "").replace(/\s/g, "");
    return ((audioUrl === '' && Object.keys(imgUrl).length === 0 && noWhiteEmptySpaces === ''));
  }

  return (

    <div className={d13.MainContainer} >


      {!subjectState && <div className={d13.subjectSelect}>Please select a subject</div>}
      <select required ref={subjectRef} onChange={checkSubject} >
        <option value='default' defaultValue='default'> select subject</option>
        <option value="Math">Math</option>
        <option value="Physics">Physics</option>
        <option value="Arabic">Arabic</option>
        <option value="French">French</option>
        <option value="English">English</option>
        <option value="Philosophy">Philosophy</option>
        <option value="Civic">Civic</option>
        <option value="History">History</option>
        <option value="Geography">Geography</option>
        <option value="Biology">Biology</option>
        <option value="Chemistry">Chemistry</option>
        <option value="Informatics">Informatics</option>
        <option value="Economics">Economics</option>
        <option value="Sociology">Sociology</option>
        <option value="Music">Music</option>
      </select>




      <p><IoText className={d13.formIcons} />Add text <br />
        <textarea onChange={textareaResize} type='text' ref={questRef} placeholder="enter question here" required /></p>


      <p><BsImageFill className={d13.formIcons} />Add image</p>


      <Suspense fallback={<div>Image</div>}>
        <MultipleImagesUploadForm
          setImagesUrlsResult={(result) => { setImgUrl(result); }}
          setImgUpState={(s) => { setImgUpState(s); console.log('img state', s) }}
          toggleUpload={toggleQuestionUpload} />
      </Suspense>



      <p><AiTwotoneAudio className={d13.formIcons} />Add audio  {!audioUpState && <> {Number((audioProgress).toFixed(1))}% <MiniLoader /> </>}</p>


      <div className={d13.audioInput}>

        {
          //  !canPlayOPUS? //check broswer if safari render a special component
          //  <div>
          //   <button onClick={()=>handleAudioUpload(audioRef.current.files[0])}>upload</button>
          //   <button  onClick={()=>{setAudioPreview('');audioRef.current.value=null}}> clear</button>
          //   <input type='file' accept="audio/*"ref={audioRef} capture onChange={()=>getAudioPreview()}/>
          //   <audio controls src={audioPreview}  /></div> :

          <RecorderHooks getBolb={b => { handleAudioUpload(b); }} />
        }

      </div>

      <div ref={scroll}></div>

      <p>
        {loader && <DotsLoader color={'linear-gradient(180deg, #0C99FF 0%, rgba(12, 80, 255, 0.97) 100%)'} />}


        {(!audioUpState || imgUpState === 'uploading') &&
          <center>Images are uploading</center>}



        {subjectState &&
          audioUpState &&
          // ( imgUpState==='done' ||imgUpState==='empty') && 
          !loader &&
          <BlueButton className={d13.UploadButton}
            onClick={() => emptyQuestion() ?
              toast.error('cannot add empty questions') :
              setToggleQuestionUpload(true)
            }>Ask Now<FaPaperPlane style={{ 'marginLeft': '5px' }} /></BlueButton>
          //
        }

      </p>

    </div>

  )
}

export default SendQuestionsForm
